

































import Vue from 'vue'
import { Component, Emit, Prop, Watch } from 'vue-property-decorator'

import { defaultShopTypeOfSelectedTariff } from '../logic/helpers'
import { Shop, Tariff, Getaway, SelectedShop, ShortTariffInfo } from '../logic/types'
import CurrencySelect from './CurrencySelect.vue'
import MakePayment from './MakePayment.vue'
import ServiceCard from './ServiceCard.vue'

@Component({
  components: {
    ServiceCard,
    CurrencySelect,
    MakePayment,
  },
  methods: {
    defaultShopTypeOfSelectedTariff,
  },
})
export default class ServicesShowcase extends Vue {
  @Prop() readonly tariffs!: Array<Tariff>

  @Prop() readonly tariffImages!: { [key: string]: string }

  @Prop() readonly period!: number

  @Prop() readonly shop!: SelectedShop

  @Prop({ type: Boolean, default: false }) multiplePayment!: boolean

  @Prop({ type: Function }) calcTotalFn!: (price: string) => number

  @Emit()
  selectTariff(tariff: Tariff) {
    return tariff
  }

  @Emit()
  updatePayInfo(info: Array<ShortTariffInfo>) {
    return info
  }

  @Watch('periodTariffs', { deep: true, immediate: true })
  onMultiplePaymentChange(tariffs: Array<Tariff>) {
    if (tariffs && tariffs.length && tariffs[0]) {
      this.updatePayInfo(tariffs.map(v => {
        return {
          name: v.name,
          price: v.shops[this.shopValue]?.[0]?.price ?? '-',
          base_price: v.shops[this.shopValue]?.[0]?.discount_base_price ?? '-',
          currency_symbol: v.shops[this.shopValue]?.[0]?.currency_symbol ?? '-',
          monthCount: v.monthCount
        }
      }))
    }
  }

  selectedTariff: Tariff | null = null

  getaway: Getaway | null = null

  get periodTariffs():Array<Tariff> {
    return this.tariffs.filter(t => t.monthCount === this.period)
  }

  get shopValue(): Shop {
    const shopsSet = new Set<Shop>()

    for (const tariff of this.tariffs) {
      for (const shop of Object.keys(tariff.shops)) {
        shopsSet.add(shop as Shop)
      }
    }

    const shopsArr: Array<Shop> = [ ...shopsSet ]

    if (this.shop.group) {
      return this.shop.group as Shop
    }

    return (shopsArr.includes(this.shop.group as Shop) ? this.shop.group as Shop : shopsArr[0]) as Shop
  }

  get defaultShop(): Shop | null {
    if (this.selectedTariff) {
      return (this as any).defaultShopTypeOfSelectedTariff(this.selectedTariff.shops)
    }
    return null
  }
}
